import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Codex from '@blumira/blu_constants';
import Schema from 'lib/schema'
import {
  useQueryControls,
  useResultControls,
  SaveRequestModal,
  decodeKey
} from 'views/Components/QueryControls';
import PropTypes from 'prop-types';

import DataSourcePicker from 'views/Components/Reporting/DataSourcePicker';
import FilterEditor from 'views/Components/Reporting/FilterEditor';
import OutputFieldsEditor from 'views/Components/Reporting/OutputFieldsEditor';
import SavedQueryModal from 'views/Components/Reporting/SavedQueryModal';
import DataTable from 'views/Components/DataTable';
import { TimeControls } from 'views/Components/TimespanPicker';
import LicenseRestriction from 'views/Components/License';

import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';

import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import Alert from '@material-ui/lab/Alert'

// ** Selectors ***********************
import { loadPageData } from 'redux/actions/Request';
import _ from 'lodash';
import Request from '../../../lib/api/Request';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minHeight: 80,
    padding: 0,
    marginRight: theme.shape.padding
  },
  textButton: {
    width: 200,
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: theme.shape.padding,
    color: theme.palette.text.primary
  },
  card: {
    marginBottom: theme.spacing(2)
  },
  dFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.shape.padding
  },
  dataSource: {
    '& input': {
      height: 28
    }
  },
  marginTop: {
    marginTop: theme.shape.padding
  },
  marginRight: {
    marginRight: theme.shape.padding
  },
  fieldsMultiSelectAlert: {
    marginTop: theme.spacing(2)
  }
}));

const generateLogTypesObject = (orgLogTypes,allLogTypes)=>{
  const orgLogTypesList = orgLogTypes.map(obj=>obj.name);
  const newLogTypesObj = {};
  for (let[key,value] of Object.entries(allLogTypes)){
    if (orgLogTypesList.includes(key)){
      newLogTypesObj[key]=value;
    }
  }
  return newLogTypesObj;
}

const isThereDataSourcesSelected = (queryControls) =>( Object.values(queryControls).find(q=>q.field==='type') && Object.values(queryControls).find(q=>q.field==='type').value.length > 0)

const isThereActiveQueryData = (activeQuery) => activeQuery  && activeQuery.length > 0;

const getNumberOfDataSources = (queryControls) => Object.values(queryControls).find(q=>q.field==='type')  ? Object.values(queryControls).find(q=>q.field==='type').value.length :0;

const populateAvailableFieldsList = (typeControl,logTypes)=>{
  if (_.isNil(typeControl) || _.isNil(logTypes)){
    return [];
  }

 return _(typeControl.value)
  .filter(obj=> obj in logTypes)
  .map(obj => logTypes[obj].all_columns)
  .flatten()
  .uniq()
  .value()
};

const Search = (props) => {
  const [selectedModel, setSelectedModel] = useState(false);
  const [queryControls, queryControlInterface] = useQueryControls('activeQuery')
  const [resultControls, resultControlInterface] = useResultControls('activeQuery')
  const [addSuggestedFields, setAddSuggestedFields] = useState(true)
  const [saveOpen, setSaveOpen] = useState(false)
  const [showSaved, setShowSaved] = useState(false)
  const [showAdvanced, setShowAdvanced] = useState(false)
  const [formError, setFormError] = useState(false) /* eslint-disable-line */
  const [anchorEl, setAnchorEl] = useState(false)
  const [extraOutputFieldsList,setExtraOutputFieldsList] = useState([]);
  const [logTypes,setLogTypes] = useState({});
  const [activeQuery,setActiveQuery] = useState([]);
  const [numberOfDataSources,setDataSourceNumber] = useState(0);
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState('')
  const [isAlertVisible, setIsAlertVisible] = useState(true)
  const [availableFieldsList,setAvailableFieldsList]=useState([]);
  const availableFieldsObj = Schema.getSchema('/bq').schema.properties;

  useEffect(()=>{
    const newNumberofDataSources = getNumberOfDataSources(queryControls);
    setDataSourceNumber(newNumberofDataSources);
    if (numberOfDataSources !== newNumberofDataSources){
      setActiveQuery([]);
    }
    else {
      setActiveQuery(props.activeQuery);
    }
  },[queryControls,props.activeQuery]); /* eslint-disable-line */

  useEffect(()=>{
    const matchedQuery = props.savedQueries.find(q=>q.id===Number(props.queryID))
    if(matchedQuery){
      if(!selectedModel || selectedModel.id !== matchedQuery.id){
        setSelectedModel(matchedQuery)
      }
    }
  },[props.queryID, props.savedQueries]) /* eslint-disable-line */

  useEffect(()=>{
    if (props.orgLogTypes){
      const orgLogTypes = generateLogTypesObject(props.orgLogTypes,props.logTypes);
      setLogTypes(orgLogTypes);
    }
  },[props.orgLogTypes]) /* eslint-disable-line */

  useEffect(() => {
    if (selectedModel) {
      const updatedUUIDs = []
      const toAddQPs = []
      const loadingQueryParams = [...selectedModel.queryParams.filter(qp=>!Array.isArray(qp)),
        ,{field:'query.id',value:selectedModel.id}
      ]
      const loadingOrQueryParams = [...selectedModel.queryParams.filter(qp=>Array.isArray(qp))]
      const overloadFields = []
      
      if(selectedModel.id === Number(props.queryID) && props.query){
        Object.keys(props.query).forEach(k=>{
          const qp = {...decodeKey(k), value:props.query[k]}
          overloadFields.push(qp.field)
          toAddQPs.push(qp)
        })
      }

      loadingQueryParams.forEach(selectedQP => {
        var matched = false
        Object.keys(queryControls).forEach(qcUUID => {
          if (
            queryControls[qcUUID].field === selectedQP.field &&
            queryControls[qcUUID].operator === selectedQP.operator &&
            !!queryControls[qcUUID].negate === !!selectedQP.negate
          ) {
            queryControlInterface.update(qcUUID, { value: selectedQP.value })
            matched = qcUUID
          }
        })
        if (matched) {
          updatedUUIDs.push(matched)
        } else if(!overloadFields.includes(selectedQP.field)){
          toAddQPs.push(selectedQP)
        }
      })

      Object.keys(queryControls).filter(qcUUID => !updatedUUIDs.includes(qcUUID) || overloadFields.includes(queryControls[qcUUID].field)).map(qcUUID => queryControlInterface.remove(qcUUID))
      Object.keys(resultControls).map(resultType => resultControlInterface.remove(resultType))
      // add values from selectedModel
      toAddQPs.map(qp => queryControlInterface.add(qp))
      loadingOrQueryParams.forEach(orParam => {
        queryControlInterface.add(orParam)
      })
      Object.keys(selectedModel.resultParams).map(resultName => resultControlInterface.update(resultName, selectedModel.resultParams[resultName]))

      props.reload()
    }
  }, [selectedModel, props.query, props.queryID]) /* eslint-disable-line */

  const populateOutputFieldsList = (firstElement,typeControl,logTypes,availableFieldsList,extraOutputFieldsList)=>{
    if (_.isNil(typeControl) || _.isNil(logTypes)){
      return [];
    }

   const arr=_(typeControl.value).filter(obj=> obj in logTypes)
    .map(obj => logTypes[obj].core_columns)
    .flatten()
    .push(...extraOutputFieldsList)
    .uniq()
    .filter(obj=>availableFieldsList.includes(obj))
    .value()
   return [firstElement,...arr];

  }
  useEffect(() => {
    const typeControl = Object.values(queryControls).find(control => control.field === 'type' && control.operator === 'in')

    const availableFieldsList = populateAvailableFieldsList(typeControl,logTypes);
    setAvailableFieldsList(availableFieldsList);
    if (typeControl && addSuggestedFields && props.ready) {
      const firstElem =!isDistinct() ? 'id':'grouped_count';

      const outputFields=populateOutputFieldsList(firstElem,typeControl,logTypes,availableFieldsList,extraOutputFieldsList)
      resultControlInterface.update('outputFields', outputFields)
    }
  }, [queryControls,props.orgLogTypes,addSuggestedFields]) /* eslint-disable-line */
  const handleAddExtraOutputField = (currentOutputFields)=>{
      setExtraOutputFieldsList(_.difference(currentOutputFields,resultControls.outputFields))
  }
  const handleRestore = () => {
    setSelectedModel(false)
    queryControlInterface.restore()
    resultControlInterface.restore()
  }

  const handleSelectModel = (model) => {
    setAddSuggestedFields(false)
    setSelectedModel(model)
  }

  const handleSelectAllTypes = () => {
    const typeControl = Object.values(queryControls).find(control => control.field === 'type' && control.operator === 'in')
    const value = Object.keys(logTypes).filter(logType => props.language[logType])
    if (typeControl) {
      setAddSuggestedFields(false)
      queryControlInterface.update(typeControl.uuid, { value })
    }
  }

  const handleSubmit = () => {
    props.reload(true)
  }

  const onSave = (queryID) => {
    setSaveOpen(false)
    props.reload(true)
  }

  const checkMenuDisabled = (contextMenu) => {
    if (contextMenu.fieldName && resultControls.outputFields?.find(field => field === contextMenu.fieldName)) {
      return false
    }
    return true
  }

  const fallbackCopyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }

  const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text)
  }

  // Context Menu Functions
  const menuCopy = (contextMenu) => {
    copyTextToClipboard(contextMenu.model[contextMenu.fieldName])
  }

  const menuFilterEq = (contextMenu) => {
    queryControlInterface.add({
      field: contextMenu.fieldName,
      value: contextMenu.model[contextMenu.fieldName],
      operator: 'eq',
      negate: false
    })
  }

  const menuFilterNeq = (contextMenu) => {
    queryControlInterface.add({
      field: contextMenu.fieldName,
      value: contextMenu.model[contextMenu.fieldName],
      operator: 'eq',
      negate: true
    })
  }

  /*
    description: The type of output that the report processing will produce; "direct" ==
      list of output objects in data field of response. Else, "jsonl", "csv",
      "xlsx", which produce signed URL to output file of given type.
  */
  const onExport = (downloadType) => {
    const transform = !resultControls.transform ? []: resultControls.transform.map(obj=>{
      delete obj.uuid;
      delete obj.boolParam;
      return obj;
    })
    const queryParams = Object.values(queryControls).map(obj=>obj);
    const request = new Request('/bq', queryParams,{
      ...resultControls,
      transform,
      outputType:downloadType
    });
    request.get()
  }

  // These functions are to support the legacy UI "distint" action
  // it will be replaced by a robust result UI in the future
  const isDistinct = () => {
    return resultControls.transform?.find(t => t.operator === 'count')
  }

  const handleDistinct = () => {
    const control = isDistinct()
    if (control) {
      const updated = resultControls.transform.filter(t => t.uuid !== control.uuid).map(t => { return { field: t.field, operator: t.operator, negate: t.negate, value: t.value } })
      resultControlInterface.update('transform', updated)
      resultControlInterface.update('outputFields',['id',...resultControls.outputFields.filter(obj=>obj !=='grouped_count')])
      resultControlInterface.update('orderBy',[...resultControls.orderBy.filter(obj=>obj.key !=='grouped_count')])
    } else {
      let transformToMap = !!resultControls?.transform?.length ? resultControls.transform : []
      const updated = transformToMap.map(t => { return { field: t.field, operator: t.operator, negate: t.negate, value: t.value } })
      updated.push({ operator: 'count', value:'grouped_count'})
      resultControlInterface.update('transform', updated)
      resultControlInterface.update('outputFields',['grouped_count',...resultControls.outputFields.filter(obj=>obj !=='id')])
    }
  }

  const toggleMoreMenu = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const getColumns = () => {
    const columns = resultControls.outputFields?.map(c => { return { title: c, field: c, searchable: true, flex: 1 } }) || []
    return columns
  }

  const getFields = (resultControls) => _.isNil(resultControls.outputFields )?
    []:
    resultControls.outputFields
      .filter(field=>field in availableFieldsObj)
      .map(c => ({ field: c } ))
  

  const handleError = (resp) => {
    if(resp !== '') {
      setErrorMessage(resp)
      setIsAlertVisible(true)
    }
  }

  const handleAlertClose = () => {
    setErrorMessage('')
    setIsAlertVisible(false)
  }

  return (
    <div>
      <SavedQueryModal
        show={showSaved}
        onClick={handleSelectModel}
        queries={props.savedQueries}
        onClose={() => setShowSaved(false)}
      />
      <SaveRequestModal
        open={saveOpen}
        refName="activeQuery"
        onClose={onSave}
      />
        {selectedModel.id && <Typography color="textSecondary" gutterBottom>Working with saved report: {selectedModel.name}</Typography>}
        <Grid container>
          {formError && (<Grid item xs={12}><Typography color="error">{formError}</Typography></Grid>)}
          <Grid className={classes.dFlex} item form="maincomponent" xs>
            <TimeControls controls={queryControls} interface={queryControlInterface} />
            <FormControl fullWidth className={classes.formControl}>
              <DataSourcePicker controls={queryControls} interface={queryControlInterface} logTypes={logTypes} language={props.language} errorMsg={(resp) => handleError(resp)} />
            </FormControl>
            <Button className={classes.textButton} onClick={()=>setShowAdvanced(!showAdvanced)} datacy={'reportShowAdvancedBtn'}>{showAdvanced ? 'Hide':'Show'} Advanced</Button>
            <ButtonGroup className={classes.marginRight} color="primary" variant="contained">
              <Button startIcon={<PlayCircleOutlineIcon />} onClick={handleSubmit} datacy={'reportSubmitButton'}>Submit</Button>
            </ButtonGroup>
            <div>
              <IconButton onClick={toggleMoreMenu} aria-controls={'simple-menu'} data-cy={'moreReportBtnMenu'}>
                <MoreHorizIcon />
              </IconButton>
              <Menu
                keepMounted
                id={'simple-menu'}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                disableScrollLock={true}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem 
                  onClick={() => {
                    onExport('jsonl')
                    setAnchorEl(null) 
                  }}
                  disabled={!isThereActiveQueryData(activeQuery)}
                >
                  Export JSONL
                </MenuItem>
                <MenuItem 
                  onClick={() => {
                    onExport('csv')
                    setAnchorEl(null) 
                  }}
                  disabled={!isThereActiveQueryData(activeQuery)}
                >
                  Export CSV
                </MenuItem>
                <LicenseRestriction requires={'query.create'}>
                  <MenuItem 
                    onClick={() => {
                      setSaveOpen(true)
                      setAnchorEl(null) 
                    }}
                    data-cy={'saveReportBtn'}
                    disabled={!isThereDataSourcesSelected(queryControls)}
                  >
                    Save Report
                  </MenuItem>
                </LicenseRestriction>
              <MenuItem
                onClick={() => {
                  handleRestore()
                  setAnchorEl(null)
                }}
              >
                Reset Report
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setShowSaved(true)
                  setAnchorEl(null)
                }}
                datacy={'loadSavedReportBtn'}
              >
                Load Saved Report
              </MenuItem>
            </Menu>
          </div>
        </Grid>
      </Grid>
      <Card className={classes.card}>
        <Collapse in={showAdvanced} timeout="auto" unmountOnExit>
          <CardContent>
            <FormControl fullWidth>
              <OutputFieldsEditor control={resultControls.outputFields} interface={resultControlInterface} fields={availableFieldsList } distinctCountsApplied={!!isDistinct()} onAddExtraOutputField={handleAddExtraOutputField}/>
            </FormControl>
            {isAlertVisible && errorMessage && <Alert severity='error' className={classes.fieldsMultiSelectAlert} onClose={handleAlertClose}>{errorMessage}</Alert>}
            <div className={classes.marginTop}>
              <FilterEditor controls={queryControls} interface={queryControlInterface} fields={getFields(resultControls)} />
            </div>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!isDistinct()}
                    onChange={handleDistinct}
                    color="primary"
                  />
                }
                label="Apply Distinct Counts to Report"
                datacy={'reportDistinctCountToggle'}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={addSuggestedFields}
                    onChange={(e) => setAddSuggestedFields(!addSuggestedFields)}
                    color="primary"
                  />
                }
                label="Add Suggested Fields"
              />
            </FormGroup>
            {/* resultControls.transform?.map(resultParam=>(<TransformParamControl key={resultParam.uuid} refName="activeQuery" param={resultParam.uuid} label={resultParam.field} />)) */}
            <Button variant={'outlined'} onClick={handleSelectAllTypes}>Select All Data Sources</Button>
          </CardContent>
        </Collapse>
      </Card>
      { activeQuery && activeQuery.length === 5000 && (<Alert severity="warning">Your search exceeded the maximum number of rows (5000)</Alert>) }
      <DataTable
        title="Results"
        data={activeQuery}
        columns={getColumns()}
        isFetching={!props.ready}
        contextMenuItems={[
          { onClick: menuCopy, text: "Copy to Clipboard", isDisabled: checkMenuDisabled },
          { onClick: menuFilterEq, text: "Add to filters", isDisabled: checkMenuDisabled },
          { onClick: menuFilterNeq, text: "Remove from results", isDisabled: checkMenuDisabled },
        ]}
      />

    </div>
  )
}

// ** Proptypes ***********************
Search.propTypes = {
  results: PropTypes.array,
  columns: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  orgId: PropTypes.string.isRequired,
  savedQueries: PropTypes.array
};

// ** Default props *******************
Search.defaultProps = {
  results: [],
  columns: [],
  logTypes: {},
  savedQueries: [],
};

const mapDispatchToProps = (dispatch) => {
  return {
    reload: (force) => dispatch(loadPageData(force))
  }
}

// ** State constants *****************
const mapStateToProps = (state) => {
  return {
    orgId: state.location.payload.orgId,
    query: state.location.query,
    queryID: state.location.payload.id1,
    logTypes: Codex.constant.api.bq.type,
    language: Codex.language.models.bq.type
  }
};

const SearchPage = connect(mapStateToProps, mapDispatchToProps)(Search)
export default SearchPage;
